<template>
  <div class="company-box">
    <el-collapse-transition>
      <div class="company-menu" v-if="show">
        <div class="input-wrap" v-if="renderList.length > 10 || searchStr">
          <span class="iconfont icon-sousuo1"></span>
          <input
            type="text"
            class="input"
            v-model="searchStr"
            @input="handleSearchCompany"
          />
          <img
            v-show="searchStr"
            src="@/assets/images/common/input_clear.png"
            class="text-clear"
            @click="clearSearch"
            alt=""
          />
        </div>
        <div class="list-wrap" ref="listWrapper">
          <ul class="company-list">
            <li
              class="item"
              :class="{ selected: item.companyId == companyId }"
              @click="selectCompany(item)"
              v-for="item in renderList"
              :key="item.companyId"
            >
              <i class="iconfont icon-round-check"></i>{{ item.companyName }}
            </li>
          </ul>
        </div>
        <div class="create-company" @click="handleCreateCompany">创建企业</div>
      </div>
    </el-collapse-transition>
    <create-company-form
      v-if="showCreateCompanyFrom"
      :visible.sync="showCreateCompanyFrom"
    ></create-company-form>
  </div>
</template>
<script>
import { getAllFarmByCompanyId } from "@/api/request/snkd.produce";
import { windowHref } from "@/utils";
import initBScroll from "@/utils/bScroll";
import { getStorage } from "@/utils/storage";
import CreateCompanyForm from "@/components/PageHeader/CreateCompanyForm";
import { mapState } from "vuex";
export default {
  components: { CreateCompanyForm },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchStr: "",
      companyId: null,
      renderList: [],
      scroll: null,
      showCreateCompanyFrom: false,
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.$nextTick(() => {
          // 重开时先销毁旧实例，避免残留实例与新实例叠加导致滚动失效
          if (this.scroll) {
            this.scroll.destroy();
            this.scroll = null;
          }
          this.scroll = initBScroll(this.$refs.listWrapper, {
            scrollbar: {
              fade: false,
              minSize: 30,
            },
          });
        });
      } else if (this.scroll) {
        // 加空值保护：show 为 false 时若实例尚未创建（或已被销毁），
        // 直接 destroy() 会抛错，中断后续逻辑
        this.scroll.destroy();
        this.scroll = null;
      }
    },
  },
  computed: {
    ...mapState(["companyList"]),
  },
  mounted() {
    if (this.companyList.length) {
      // 如果store有所有的企业列表
      this.renderList = this.companyList;
    } else {
      // 如果store中没有数据，主动派发一个请求
      this.$store.dispatch("getCompanyList").then((res) => {
        this.renderList = res;
      });
    }
    const companyInfo = getStorage("COMPANYINFO");
    this.companyId = companyInfo ? companyInfo.companyId : null;
  },
  methods: {
    // 选择企业
    async selectCompany(item) {
      this.companyId = item.companyId;
      this.closeMenu();
      // 查询切换后的企业农场
      const res = await getAllFarmByCompanyId({ companyId: this.companyId });
      if (res.respCode === 0) {
        let farmIdTemp = res.obj[0].farmId;
        res.obj.forEach((ele) => {
          if (ele.chooseFlag) {
            farmIdTemp = ele.farmId;
          }
        });
        windowHref("/home/home", {
          companyId: item.companyId,
          farmId: farmIdTemp,
        });
      }
    },
    // 搜索企业
    handleSearchCompany() {
      this.renderList = this.companyList.filter((company) => {
        return !(company.companyName.indexOf(this.searchStr) === -1);
      });
    },
    // 清空搜索
    clearSearch() {
      this.searchStr = "";
      this.renderList = this.companyList;
    },
    // 创建企业
    handleCreateCompany() {
      this.showCreateCompanyFrom = true;
      this.closeMenu();
    },
    closeMenu() {
      this.$emit("update:show", false);
    },
  },
};
</script>
<style scoped lang="scss">
/* 与老端 frp_company_web 企业切换面板保持一致（reset.css .account_pannel .total_company 系列） */
.company-menu {
  position: absolute;
  top: 85px;
  right: 20px;
  width: 360px;
  background: #fff;
  font-size: 14px;
  color: #333;
  padding: 0;
  line-height: 50px;
  border: none;
  border-radius: 12px;
  // 圆角裁切：列表滚动时不露出直角
  overflow: hidden;
  transition: all 0.1s;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  .input-wrap {
    position: relative;
    // 左右外边距取「企业名称文字起点」34px，使搜索框：
    //   1) 左右内缩一致（同一数值，天然对称）；
    //   2) 左边缘与下方企业名称文字左对齐。
    // 34 的构成：列表项 .item padding-left 14 + 勾选图标 14 + 图标 margin-right 6 = 34。
    // ⚠️ 若调整 .item 的内边距或勾选图标尺寸，此处需同步（两处必须一起改才保持对齐）。
    // 历史：原为 width: 82% + margin: auto（老端同款）→ 左右各 32.4px，与名称差 1.6px，
    // 视觉上「几乎对齐但没对齐」；老端同样存在该偏差。
    margin: 10px 34px 0;
    height: 34px;
    border-radius: 40px;
    background-color: #f5f5f5;
    padding: 0 14px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .iconfont {
      font-size: 18px;
      color: #999;
      margin-right: 0;
    }
    .input {
      flex: 1;
      margin-left: 8px;
      font-size: 14px;
      color: #333;
      // 老端 .input-box 亦为 max-width: 120px，但配合 82% 外框并不会真的截断
      // （120px 上限是给内部文本用的；保留同值以免与老端行为分叉）
      max-width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      background-color: transparent;
      height: 20px;
      line-height: 20px;
      outline: none;
      border: none;
      vertical-align: middle;
    }
    .text-clear {
      cursor: pointer;
      position: absolute;
      top: 8px;
      // 右内缩 14px，与左侧搜索图标的 14px 内边距一致（原为 8px，左右视觉不对称）
      right: 14px;
      width: 18px;
      height: 18px;
    }
  }
  // 老端为 max-height + 上下 padding（条目少时面板自适应收缩），非固定高
  .list-wrap {
    position: relative;
    max-height: 207px;
    padding: 10px 0;
    overflow: hidden;
    .company-list {
      // ⚠️ 这里**不能**再给 max-height（老端 reset.css 的 .company_list 有 207px，本端曾照抄）。
      // better-scroll 判断「能否滚动」是比较 wrapper 的 clientHeight 与内容元素的
      // offsetHeight：若内容也被压到 207px，就永远小于 wrapper（207 + 上下 padding 20 = 227），
      // hasVerticalScroll 恒为 false、maxScrollY 恒为 0 —— 列表滚不动（本次故障根因，实测 20 条时
      // 内容 offsetHeight 207 / scrollHeight 760）。
      // 去掉后：内容按实际高度撑开，wrapper 由 max-height 裁切 → 既保留「条目少时面板自适应收缩」，
      // 又让 better-scroll 正常识别溢出并滚动。
      max-height: none;
      .item {
        height: 38px;
        line-height: 38px;
        padding: 0 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        // 老端：未选中时勾选图标隐藏（占位保留），选中才显示
        // margin-right 6px 对齐老端 reset.css 的全局 .iconfont 规则（本端为 vendor 文件，无此值）
        .iconfont {
          opacity: 0;
          margin-right: 6px;
          font-size: 14px;
        }
        &.selected {
          color: $--color-primary;
          .iconfont {
            opacity: 1;
          }
        }
      }
    }
    ::v-deep .bscroll-vertical-scrollbar .bscroll-indicator {
      background: #cccccc !important;
    }
  }
  .create-company {
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-top: 1px solid #ededed;
    color: $--color-primary;
  }
}
</style>
